// eslint-disable-next-line no-restricted-imports
import dayjs from 'dayjs';
import dayjsTZ from 'dayjs/plugin/timezone';


dayjs.extend(dayjsTZ);


export const SYSTEM_TIMEZONE_IANA = dayjs.tz.guess();
